<template>
  <main id="set-new-password-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Contenitore del form -->
    <div id="set-password-form">
      <!-- Form -->
      <form class="set-password-form" @submit.prevent="resetPassword">
        <h1>Reimposta Password</h1>
        <!-- Prima password + toggle -->
        <div class="password-field">
          <input
            id="set-password"
            :type="showNewPassword ? 'text' : 'password'"
            placeholder="Nuova password"
            v-model="newPassword"
            required
          />
          <!-- Bottone occhio/lucchetto -->
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword"
          >
            <!-- Se showNewPassword è false, mostra icona occhio chiuso. Altrimenti, occhio aperto. -->
            <i v-if="!showNewPassword" class="fa-solid fa-eye-slash"></i>
            <i v-else class="fa-solid fa-eye"></i>
          </button>
        </div>

        <!-- Seconda password + toggle -->
        <div class="password-field">
          <input
            id="set-password2"
            :type="showNewPassword2 ? 'text' : 'password'"
            placeholder="Conferma password"
            v-model="newPassword2"
            required
          />
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword2"
          >
            <i v-if="!showNewPassword2" class="fa-solid fa-eye-slash"></i>
            <i v-else class="fa-solid fa-eye"></i>
          </button>
        </div>

        <!-- Bottone invio -->
        <button
          id="reset-button"
          type="submit"
          :disabled="
            !newPassword || !newPassword2 || newPassword !== newPassword2
          "
        >
          REIMPOSTA PASSWORD
        </button>
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: "SetNewPasswordPage",
  data() {
    return {
      newPassword: "",
      newPassword2: "",
      errorMessage: "",
      successMessage: "",
      /* Variabili per mostrare/nascondere le password */
      showNewPassword: false,
      showNewPassword2: false,
    };
  },
  methods: {
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleNewPassword2() {
      this.showNewPassword2 = !this.showNewPassword2;
    },
    async resetPassword() {
      try {
        const token = this.$route.query.token;
        if (this.newPassword !== this.newPassword2) {
          this.errorMessage = "Le password non corrispondono!";
          this.$toast.error(this.errorMessage);
          return;
        }
        const payload = { password: this.newPassword };
        const response = await this.$axios.post(
          `/auth/reset-password?token=${token}`,
          payload
        );
        if (response.status === 200) {
          this.successMessage =
            response.data?.details || "Password reimpostata con successo!";
          this.$toast.success(this.successMessage);
          this.errorMessage = "";
        }
        // Reindirizza dopo 2 secondi
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        console.error("Errore reimpostazione password: ", error);
        // Se lo status è 400 => token scaduto o invalido
        if (error.response?.status === 400) {
          this.errorMessage =
            error.response?.data?.details ||
            "Token scaduto o non valido. Richiedi nuovamente il link di recupero password.";
          this.$toast.error(this.errorMessage);
          // Reindirizza dopo 2 secondi a /auth/verify-email
          setTimeout(() => {
            this.$router.push("/login/verify-email");
          }, 2000);
        } else {
          // Altri errori generici
          this.errorMessage =
            error.response?.data?.error ||
            "Errore durante la reimpostazione della password.";
          this.$toast.error(this.errorMessage);
        }
      }
    },
  },
};
</script>

<style src="@/css/SetNewPassword.css"></style>
